import EntryPoint from 'Engine/EntryPoint';

export default new class XXXDataParser {
    parseInit(data) {
        let newData = {};
        newData.action = 'init';
        newData.balance = data.balance;
        newData.params = {
            betPossible: data.available_bets
        };
        newData.current = {
            bet: data.bet_amount,
            lines: 5
        };

        newData.currencyInfo = {
            decimals: data.decimals,
            symbol: data.currency,
            currency: data.currency
        };

        newData.bonusGame = data.bonus;
        newData.jackpotsCount = data.bonus.field_coeffs.flat().reduce((count, coeff) => count + (data.jackpots_coeffs.includes(coeff) ? coeff : 0), 0);
        newData.paytableInfo = data.paytable;
        newData.jackpotCoeffs = data.jackpots_coeffs;
        newData.freebets = data.freebets;

        return newData;
    }

    parseSpin(data) {
        let newData = {};
        newData.action = 'spin';
        newData.balance = data.balance;
        newData.spin = {
            reels: data.spin.reels,
            coeffs: data.spin.reels_coeffs,
            winnings: this.makeWinnings(data),
            bet: data.bet_amount,
        };
        newData.bonusGame = data.bonus;
        newData.jackpotsCount = data.bonus.field_coeffs.flat().reduce((count, coeff) => count + (data.jackpots_coeffs.includes(coeff) ? coeff : 0), 0);
        newData.jackpotCoeffs = data.jackpots_coeffs;
        newData.freebets = data.freebets;

        return newData;
    }

    makeWinnings( data) {
        const spinData = data.spin;
        let winnings = {};
        winnings.totalWin = 0;

            winnings.lines = [];
        console.log(EntryPoint.configData.payLines);
        if (spinData) {
            for (const lineNumber in spinData.win_lines) {
                const lineLeng = spinData.lines_icons[lineNumber];
                if (lineLeng < 3) continue;
                let line = {};
                line.path = EntryPoint.configData.payLines[lineNumber - 1].concat().splice(0, lineLeng);
                // line.line = this.linesRelation[winData.payline.number];
                line.line = lineNumber - 1;
                line.count = lineLeng;
                line.win = spinData.win_lines[lineNumber] * data.bet_amount;
                winnings.lines.push(line);
            }

            winnings.totalWin = spinData.win_amount;
        }

        return winnings;
    }
}
